import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 2c-4.406 0-8 3.594-8 8 0 3.346 2.073 6.219 5 7.41V20a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2.596a8 8 0 0 0 1.123-.549 1 1 0 1 0-1.033-1.71A5.95 5.95 0 0 1 12 16c-3.326 0-6-2.674-6-6s2.674-6 6-6a5.96 5.96 0 0 1 2.57.578 1 1 0 1 0 .86-1.807A8 8 0 0 0 12 2m6.064 3a.254.254 0 0 0-.252.225l-.117 1.011a4 4 0 0 0-1.3.752l-.938-.406a.25.25 0 0 0-.318.107L14.2 8.311a.254.254 0 0 0 .069.33l.806.6A4 4 0 0 0 15 10c0 .26.028.513.076.76l-.806.6a.253.253 0 0 0-.069.33l.938 1.62a.25.25 0 0 0 .318.106l.938-.404c.379.329.816.584 1.3.752l.117 1.011a.254.254 0 0 0 .252.225h1.872a.254.254 0 0 0 .252-.225l.117-1.011a4 4 0 0 0 1.3-.752l.938.406a.25.25 0 0 0 .318-.107l.938-1.622a.254.254 0 0 0-.069-.33l-.806-.6c.048-.246.076-.499.076-.759s-.028-.513-.076-.76l.806-.6a.253.253 0 0 0 .069-.33l-.938-1.62a.25.25 0 0 0-.318-.108l-.938.406a4 4 0 0 0-1.3-.752l-.117-1.011A.254.254 0 0 0 19.936 5zM19 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }